/* AM-CART — carrito lateral propio de Xiomara Vargas.

   Reemplaza a UpCart. Reglas de upsell desde metaobjetos "Regla de Upsell".

   Se dibuja en Shadow DOM para que el CSS del tema no lo toque. */

(function () {

  'use strict';



  var cfgEl = document.getElementById('am-cart-config');

  if (!cfgEl) return;

  var CFG;

  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { console.warn('[am-cart] config inválida', e); return; }



  var T = CFG.textos;

  var DEBUG = /[?&]amcart=1/.test(location.search);

  var log = function () { if (DEBUG) console.log.apply(console, ['[am-cart]'].concat([].slice.call(arguments))); };



  /* ---------- dinero ---------- */

  function money(cents) {

    var v = (cents || 0) / 100;

    var fmt = CFG.moneyFormat || '${{amount}}';

    var num = v.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, num).replace(/<[^>]*>/g, '');

  }

  /* Pide la imagen al CDN por ALTURA, como UpCart (&height=N), no por ancho (_NNNx).

     Así la proporción se conserva y con object-fit:contain se ve la prenda entera. */

  function imagenPorAltura(url, alto) {

    if (!url) return '';

    var limpia = String(url).split('&height=')[0].split('&width=')[0];

    return limpia + (limpia.indexOf('?') === -1 ? '?' : '&') + 'height=' + alto;

  }



  function esc(s) {

    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {

      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];

    });

  }



  /* Iconos calcados de UpCart (Polaris) para que el carrito sea indistinguible */

  var ICONO_ETIQUETA = '<svg viewBox="0 0 20 20" aria-hidden="true"><path fill-rule="evenodd" d="M8.575 4.649a3.75 3.75 0 0 1 2.7-1.149h1.975a3.25 3.25 0 0 1 3.25 3.25v2.187a3.25 3.25 0 0 1-.996 2.34l-4.747 4.572a2.5 2.5 0 0 1-3.502-.033l-2.898-2.898a2.75 2.75 0 0 1-.036-3.852l4.254-4.417Zm4.425 3.351a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"/></svg>';

  var ICONO_PAPELERA = '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M11.5 8.25a.75.75 0 0 1 .75.75v4.25a.75.75 0 0 1-1.5 0v-4.25a.75.75 0 0 1 .75-.75Z"/><path d="M9.25 9a.75.75 0 0 0-1.5 0v4.25a.75.75 0 0 0 1.5 0v-4.25Z"/><path fill-rule="evenodd" d="M7.25 5.25a2.75 2.75 0 0 1 5.5 0h3a.75.75 0 0 1 0 1.5h-.75v5.45c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311c-.642.327-1.482.327-3.162.327h-.4c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311c-.327-.642-.327-1.482-.327-3.162v-5.45h-.75a.75.75 0 0 1 0-1.5h3Zm1.5 0a1.25 1.25 0 1 1 2.5 0h-2.5Zm-2.25 1.5h7v5.45c0 .865-.001 1.423-.036 1.848-.033.408-.09.559-.128.633a1.5 1.5 0 0 1-.655.655c-.074.038-.225.095-.633.128-.425.035-.983.036-1.848.036h-.4c-.865 0-1.423-.001-1.848-.036-.408-.033-.559-.09-.633-.128a1.5 1.5 0 0 1-.656-.655c-.037-.074-.094-.225-.127-.633-.035-.425-.036-.983-.036-1.848v-5.45Z"/></svg>';



  /* ---------- estilos ---------- */

  var CSS = `

/* OJO: no usar "all: initial" en :host. Con el body en display:grid del tema

   colapsaba el contenedor a display:none y el cajón nunca se veía.

   El Shadow DOM ya aísla el CSS del tema; lo único que cruza son las propiedades

   heredables (tipografía), que justamente queremos heredar. */

:host { display: block !important; }

*, *::before, *::after { box-sizing: border-box; }

.wrap { font-family: inherit; line-height: 1.5; letter-spacing: normal; text-transform: none; }

/* NEGRO puro con opacidad 0.4 (como UpCart), no rgba al 50%. Así la franja que

   queda bajo la tarjeta —la zona de la barra del navegador en el móvil— se ve negra. */

.backdrop {

  position: fixed; inset: 0; background: #000000;

  opacity: 0; visibility: hidden; transition: opacity .3s ease, visibility .3s ease;

  z-index: 2147483646;

}

.backdrop.on { opacity: .4; visibility: visible; }

.card {

  position: fixed; top: 0; right: 0; height: 100%; width: 440px; max-width: 100%;

  background: #FFFFFF; color: #000000; display: flex; flex-direction: column;

  transform: translateX(100%); transition: transform .3s cubic-bezier(.4,0,.2,1);

  z-index: 2147483647; box-shadow: -2px 0 20px rgba(0,0,0,.08);

}

.card.on { transform: translateX(0); }



/* cabecera */

.hd { position: relative; display: flex; flex-direction: column; align-items: center; justify-content: center;

      gap: 8px; padding: 22px 20px 18px; border-bottom: 1px solid rgba(0,0,0,.1); flex: 0 0 auto; }

/* medidas calcadas de UpCart: título 16/700, botón cerrar CUADRADO de 30px */

.hd .brand { display: flex; flex-direction: column; align-items: center; gap: 7px; text-align: center; }
.hd .brand-logo img { height: 26px; width: auto; display: block; }
.hd .brand-name { margin: 0; font-size: 18px; font-weight: 700; line-height: 1.1; letter-spacing: .4px; color: #121212; }
.hd .brand-proof { display: inline-flex; align-items: center; gap: 8px; font-size: 12px; line-height: 1; color: #121212; font-weight: 700; }
.hd .brand-proof .am-tp-stars { display: inline-flex; gap: 2px; line-height: 0; }
.hd .brand-proof .am-tp { width: 14px; height: 14px; display: inline-flex; background: #00b67a; }
.hd .brand-proof .am-tp svg { width: 14px; height: 14px; fill: #ffffff; display: block; }
.hd .brand-proof .am-tp-half { background: linear-gradient(90deg, #00b67a 50%, #dddddd 50%); }
.hd .brand-proof .rate { font-weight: 700; color: #121212; }
.hd .brand-proof .rated { color: #121212; }

.hd .x { position: absolute; top: 16px; right: 16px; width: 30px; height: 30px; border-radius: 0; border: 1px solid #000000;

         background: rgba(0,0,0,.047); display: flex; align-items: center; justify-content: center;

         cursor: pointer; padding: 0; }

.hd .x:hover { background: rgba(0,0,0,.08); }

.hd .x svg { width: 12px; height: 12px; fill: #637381; }



/* cuerpo — flex en columna para poder empujar los upsells abajo, como UpCart */

.body { flex: 1 1 auto; overflow-y: auto; overflow-x: hidden; display: flex; flex-direction: column; }



/* recompensas */

.rw { padding: 18px 30px 36px; }

.rw__msg { text-align: center; font-size: 16px; line-height: 28.8px; margin: 0 0 20px; }

.rw__msg p { margin: 0; }

.rw__bar { display: flex; gap: 4px; position: relative; height: 8px; }

.rw__seg { flex: 1 1 0; position: relative; height: 8px; background: #E2E2E2; border-radius: 4px; }

.rw__fill { position: absolute; inset: 0 auto 0 0; background: #222222; border-radius: 4px;

            width: 0; transition: width .4s ease; }

/* Círculo de nivel: gris CLARO con la etiqueta oscura mientras no se alcanza,

   y oscuro con la etiqueta blanca al conseguirlo. Al revés se leía como "ya logrado". */

.rw__pin { position: absolute; right: -15px; top: 50%; transform: translateY(-50%);

           width: 30px; height: 30px; border-radius: 50%; background: #E2E2E2;

           display: flex; align-items: center; justify-content: center; z-index: 1; }

.rw__seg.done .rw__pin { background: #222222; }

.rw__pin svg { width: 20px; height: 20px; fill: #4D4949; }

.rw__seg.done .rw__pin svg { fill: #FFFFFF; }

/* Absolutas: así NO suman altura al bloque y las etiquetas caen dentro del

   relleno inferior de 36px, igual que UpCart (bloque total = 111px). */

.rw__labels { display: flex; gap: 4px; position: absolute; top: 100%; left: 0; right: 0; margin-top: 14px; }

.rw__lb { flex: 1 1 0; text-align: right; font-size: 11px; color: #444; white-space: nowrap; }



/* artículos */

.items { list-style: none; margin: 0; padding: 0; }

.item { display: flex; gap: 14px; padding: 16px 30px; align-items: flex-start; }

/* contain, NO cover: UpCart muestra la prenda entera. Con cover se recortaba

   la cabeza o los pies del modelo, que es lo que se veía mal. */

.item__img { width: 88px; height: 88px; flex: 0 0 88px; object-fit: contain; display: block; background: transparent; }

.item__info { flex: 1 1 auto; min-width: 0; }

.item__top { display: flex; justify-content: space-between; gap: 10px; align-items: flex-start; }

.item__title { margin: 0; font-size: 16px; font-weight: 600; line-height: 20.8px; }

.item__title a { color: inherit; text-decoration: none; }

.item__rm { background: none; border: 0; cursor: pointer; padding: 0; flex: 0 0 auto; line-height: 0; }

.item__rm:hover svg { fill: #202223; }

.item__rm svg { width: 20px; height: 20px; fill: #637381; }

/* UpCart no usa un gris propio: pinta negro al 40% de opacidad */

.item__opt { font-size: 15px; color: #000000; opacity: .4; margin: 4px 0 6px; }

/* Tipografía de precios calcada de UpCart: el tachado es NEGRO (no gris),

   el precio de venta 15/500 y el ahorro 15/700 (en negrita). */

.item__prices { display: flex; flex-wrap: wrap; gap: 6px; align-items: baseline; }

.item__was { text-decoration: line-through; color: #000000; opacity: .4; font-size: 14px; font-weight: 400; line-height: 25.2px; }

.item__now { color: #ff0000; font-size: 15px; font-weight: 500; line-height: 27px; }

.item__save { color: #2ea818; font-size: 15px; font-weight: 700; line-height: 22.5px; }



/* Selector de cantidad: 100x28, esquinas 4px, separadores grises, signos a 10px */

.qty { display: inline-flex; align-items: center; border: 1px solid #cccccc; border-radius: 4px;

       margin-top: 10px; width: 100px; height: 28px; overflow: hidden; background: #ffffff; }

.qty button { width: 29px; height: 26px; background: #ffffff; border: 0; cursor: pointer;

              font-family: Arial, sans-serif; font-size: 10px; line-height: 1; color: #000;

              flex: 0 0 29px; padding: 0; }

.qty button:first-of-type { border-right: 1px solid #dddddd; }

.qty button:last-of-type { border-left: 1px solid #dddddd; }

.qty button:disabled { opacity: .35; cursor: default; }

.qty span { flex: 1 1 auto; text-align: center; font-size: 14px; line-height: 26px; }



/* upsells — margin-top:auto los empuja al fondo del cuerpo, igual que UpCart */

[data-up] { margin-top: auto; }

/* Sin relleno lateral: las flechas (26px cada una) ocupan los extremos y la tarjeta

   queda en 384 en escritorio / 295 en móvil, exactamente como UpCart. */

.up { padding: 36px 0 24px; }

/* Flechas EN EL FLUJO (columnas de 26px) con la ventana en medio, como UpCart.

   Antes iban absolutas con left/right negativos y acababan pegadas al borde del cajón. */

.up__row { display: flex; align-items: center; }

.up__win { overflow: hidden; flex: 1 1 auto; min-width: 0; padding: 0 2px; }

.up__track { display: flex; transition: transform .35s ease; min-width: 0; }

/* min-width:0 es imprescindible: sin él, el título en una sola línea (nowrap) hace

   crecer la diapositiva por encima del 100% y arrastra toda la tarjeta fuera del cajón. */

.up__slide { flex: 0 0 100%; min-width: 0; padding: 0; }

.tile { display: flex; gap: 12px; align-items: center; background: #f6f6f7; padding: 16px; border-radius: 8px; }

.tile__img { width: 90px; height: 90px; flex: 0 0 90px; object-fit: contain;

             background: transparent; border-radius: 4px; }

.tile__info { flex: 1 1 auto; min-width: 0; }

/* Una sola línea con corte duro, como UpCart (sin puntos suspensivos) */

.tile__title { font-size: 15px; font-weight: 600; margin: 0 0 4px; line-height: 22.5px;

               white-space: nowrap; overflow: hidden; text-overflow: clip; }

.tile__title a { color: inherit; text-decoration: none; }

.tile__prices { display: flex; gap: 6px; align-items: baseline; margin-bottom: 8px; }

.tile__was { text-decoration: line-through; color: #000000; opacity: .4; font-size: 13px; font-weight: 400; line-height: 16.9px; }

.tile__now { color: #ff0000; font-size: 15px; font-weight: 400; line-height: 19.5px; }

.tile__bottom { display: flex; gap: 6px; align-items: center; }

/* flex-basis 0 + width:100% evita que el <select> imponga su ancho mínimo intrínseco

   (se plantaba en 137px y cortaba el botón "Añadir" en cajones estrechos). */

.tile__sel { flex: 1 1 0; width: 100%; max-width: 148px; min-width: 45px; height: 34px;

             font-family: Arial, sans-serif; font-size: 12px; padding: 8px;

             border: 1px solid #cccccc; background: #f9f9f9; border-radius: 4px; }

/* 90px como UpCart; puede ceder hasta 72px en pantallas muy estrechas para que

   ni el botón ni el selector queden inutilizables ni se corte la tarjeta. */

.tile__add { flex: 0 1 90px; width: 90px; min-width: 72px; height: 34px; background: #000000;

             color: #FFFFFF; border: 0; border-radius: 0; padding: 8px; font-family: Arial, sans-serif;

             font-size: 13.3333px; font-weight: 600; cursor: pointer; white-space: nowrap; }

.tile__add:hover { color: #e9e9e9; }

.tile__add:disabled { opacity: .5; cursor: default; }

/* Flechas más grandes (28px) que las de UpCart (~13) para que se noten más,

   a petición del usuario. Mantienen la columna de 26px para no desplazar la tarjeta. */

.up__nav { flex: 0 0 26px; width: 26px; background: none; border: 0; padding: 0;

           cursor: pointer; font-size: 28px; line-height: 1; color: #000000; }

.up__nav:disabled { color: rgba(16,16,16,.3); cursor: default; }



/* pie */

/* El margen inferior respeta la zona segura del móvil (indicador de inicio del iPhone).

   Sin esto, el botón de pago queda pegado al borde y en el borrador lo tapa además

   la barra de vista previa de Shopify. */

/* Pie con FONDO GRIS #f6f6f7 y relleno de 23px, como UpCart. */

.ft { flex: 0 0 auto; background: #f6f6f7;

      padding: 23px 23px calc(23px + var(--am-barra-preview, 0px));

      border-top: 1px solid rgba(0,0,0,.1); }

.ft__row { display: flex; justify-content: space-between; align-items: center; gap: 8px; margin-bottom: 12px; }

.ft__left { display: flex; align-items: center; gap: 8px; min-width: 0; flex-wrap: wrap; }

.ft__label { font-size: 14px; }

/* el importe es NEGRO en UpCart, no verde (el verde es solo el "Ahorras" del artículo) */

.ft__amount { font-size: 14px; color: #000000; white-space: nowrap; }

/* pastilla con el nombre del descuento aplicado */

.ft__tag { display: inline-flex; align-items: center; gap: 2px; background: rgba(0,0,0,.05);

           border-radius: 4px; padding: 2px 6px 2px 4px; font-size: 13px; font-weight: 600;

           color: #585858; text-transform: uppercase; }

.ft__tag svg { width: 16px; height: 16px; fill: #585858; flex: 0 0 auto; }

.ft__form { margin: 0; }

.ft__btn { display: block; width: 100%; background: #000000; color: #FFFFFF; border: 0; border-radius: 0;

           font-family: inherit;

           padding: 14px; font-size: 15px; font-weight: 600; cursor: pointer; text-align: center;

           text-decoration: none; line-height: 22.5px; }

.ft__btn:hover { color: #e9e9e9; }

/* Una sola fila, todos del mismo ancho: flex:1 1 0 reparte el espacio por igual

   sin importar cuántos iconos haya, y se encogen juntos en pantallas estrechas. */

.ft__badges { display: flex; flex-wrap: nowrap; gap: 6px; margin: 14px 0 0; align-items: center; }

.ft__badges svg { flex: 1 1 0; min-width: 0; width: auto; height: auto; max-height: 26px; display: block; }



/* vacío */

.empty { padding: 60px 30px; text-align: center; color: #6b7177; font-size: 15px; }



/* ---- MÓVIL ----

   Va al FINAL a propósito: al tener la misma especificidad que las reglas de

   arriba, si se pone antes gana la de escritorio y la cabecera se queda en 30px. */

@media (max-width: 749px) {

  .card { width: 90%; }            /* 351px en una pantalla de 390, como UpCart */

  .hd   { padding: 20px; }         /* 71px de alto (en escritorio son 30px → 91px) */

  .rw   { padding: 18px 20px 36px; }

  .item { padding: 16px 20px; }

  .up   { padding: 28px 0 20px; }

  .ft   { padding: 23px 23px calc(23px + var(--am-barra-preview, 0px)); }

}

`;



  /* ---------- montaje ---------- */

  var host = document.getElementById('amCart');

  if (!host) return;

  var root = host.attachShadow({ mode: 'open' });

  var style = document.createElement('style');

  style.textContent = CSS;

  root.appendChild(style);



  var wrap = document.createElement('div');

  wrap.className = 'wrap';

  wrap.innerHTML =

    '<div class="backdrop" data-cerrar></div>' +

    '<aside class="card" role="dialog" aria-modal="true" aria-label="Carrito">' +

      '<div class="hd">' +

        '<div class="brand">' +
          '<div class="brand-logo" data-brandlogo></div>' +
          '<div class="brand-proof" data-brandproof></div>' +
        '</div>' +

        '<button class="x" data-cerrar aria-label="Cerrar carrito">' +

          '<svg viewBox="0 0 20 20"><path d="m11.414 10 6.293-6.293a1 1 0 1 0-1.414-1.414L10 8.586 3.707 2.293a1 1 0 0 0-1.414 1.414L8.586 10l-6.293 6.293a1 1 0 1 0 1.414 1.414L10 11.414l6.293 6.293a1 1 0 0 0 1.414-1.414z"/></svg>' +

        '</button>' +

      '</div>' +

      '<div class="body">' +

        '<div data-rw></div>' +

        '<ul class="items" data-items></ul>' +

        '<div data-up></div>' +

      '</div>' +

      '<div class="ft" data-ft></div>' +

    '</aside>';

  root.appendChild(wrap);



  var $ = function (sel) { return wrap.querySelector(sel); };

  var elBackdrop = $('.backdrop'), elCard = $('.card'), elBrandLogo = $('[data-brandlogo]'), elBrandProof = $('[data-brandproof]');

  /* ---------- marca (logo + social proof) ---------- */
  (function renderMarca(){
    var m = CFG.marca; if (!m || !m.activo) { return; }
    if (m.logo) { var im = new Image(); im.src = m.logo; im.alt = m.nombre || ''; elBrandLogo.appendChild(im); }
    else { elBrandLogo.innerHTML = '<p class="brand-name"></p>'; elBrandLogo.firstChild.textContent = m.nombre || ''; }
    var star = '<svg viewBox="0 0 24 24"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg>';
    var tiles = ''; for (var i = 0; i < 4; i++) { tiles += '<span class="am-tp">' + star + '</span>'; } tiles += '<span class="am-tp am-tp-half">' + star + '</span>';
    var html = '<span class="am-tp-stars" aria-hidden="true">' + tiles + '</span>';
    if (m.rating) { html += '<span class="rate"></span>'; }
    if (m.texto)  { html += '<span class="rated"></span>'; }
    elBrandProof.innerHTML = html;
    var rEl = elBrandProof.querySelector('.rate'); if (rEl) { rEl.textContent = m.rating; }
    var tEl = elBrandProof.querySelector('.rated'); if (tEl) { tEl.textContent = m.texto; }
  })();

  var elRw = $('[data-rw]'), elItems = $('[data-items]'), elUp = $('[data-up]'), elFt = $('[data-ft]');



  /* ---------- estado ---------- */

  var cart = null;

  var upsellCache = {};   // handle -> productos

  var comparaCache = {};  // handle de producto -> { variantId: compare_at_price en céntimos }

  var upsellSlide = 0;

  var abierto = false;

  var ocupado = false;



  /* ---------- red ---------- */

  function getCart() {

    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });

  }

  function cambiar(linea, cantidad) {

    return fetch('/cart/change.js', {

      method: 'POST',

      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },

      body: JSON.stringify({ line: linea, quantity: cantidad })

    }).then(function (r) { return r.json(); });

  }

  function agregar(variantId, cantidad) {

    return fetch('/cart/add.js', {

      method: 'POST',

      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },

      body: JSON.stringify({ items: [{ id: variantId, quantity: cantidad || 1 }] })

    }).then(function (r) { return r.json(); });

  }

  function traerColeccion(handle, limite) {

    var k = 'c:' + handle;

    if (upsellCache[k]) return Promise.resolve(upsellCache[k]);

    return fetch('/collections/' + handle + '/products.json?limit=' + (limite || 10))

      .then(function (r) { return r.json(); })

      .then(function (j) { upsellCache[k] = j.products || []; return upsellCache[k]; })

      .catch(function () { return []; });

  }

  function traerProducto(handle) {

    var k = 'p:' + handle;

    if (upsellCache[k]) return Promise.resolve(upsellCache[k]);

    return fetch('/products/' + handle + '.js')

      .then(function (r) { return r.json(); })

      .then(function (j) { upsellCache[k] = [j]; return upsellCache[k]; })

      .catch(function () { return []; });

  }



  /* ---------- recompensas ---------- */

  function pintarRecompensas() {

    var cfg = CFG.recompensas;

    if (!cfg || !cfg.activo || !cart) { elRw.innerHTML = ''; return; }

    var tiers = cfg.tiers || [];

    if (!tiers.length) { elRw.innerHTML = ''; return; }



    var n = cart.item_count || 0;

    var ultimo = tiers[tiers.length - 1].cantidad;

    var siguiente = null;

    for (var i = 0; i < tiers.length; i++) { if (n < tiers[i].cantidad) { siguiente = tiers[i]; break; } }



    var msg = siguiente

      ? siguiente.texto.replace('{n}', siguiente.cantidad - n)

      : cfg.textoFinal;



    var segs = '', labels = '';

    var previo = 0;

    for (var j = 0; j < tiers.length; j++) {

      var meta = tiers[j].cantidad;

      var tramo = meta - previo;

      var avance = Math.min(Math.max(n - previo, 0), tramo);

      var pct = tramo > 0 ? (avance / tramo) * 100 : 0;

      var listo = n >= meta;

      segs += '<div class="rw__seg' + (listo ? ' done' : '') + '">' +

                '<div class="rw__fill" style="width:' + pct + '%"></div>' +

                '<div class="rw__pin">' + ICONO_ETIQUETA + '</div>' +

              '</div>';

      labels += '<div class="rw__lb">' + esc(tiers[j].etiqueta) + '</div>';

      previo = meta;

    }



    elRw.innerHTML =

      '<div class="rw">' +

        '<div class="rw__msg"><p>' + msg + '</p></div>' +

        '<div class="rw__bar">' + segs + '</div>' +

        '<div class="rw__labels">' + labels + '</div>' +

      '</div>';

    log('recompensas: ' + n + ' art., meta final ' + ultimo);

  }



  /* Trae el compare_at_price de cada producto del carrito.

     /cart.js no lo incluye, así que hay que pedirlo a /products/{handle}.js (precios en céntimos). */

  function enriquecerPrecios() {

    if (!cart || !cart.items.length) return Promise.resolve();

    var pendientes = [];

    cart.items.forEach(function (it) {

      if (it.handle && !comparaCache[it.handle] && pendientes.indexOf(it.handle) === -1) pendientes.push(it.handle);

    });

    if (!pendientes.length) return Promise.resolve();

    return Promise.all(pendientes.map(function (h) {

      return fetch('/products/' + h + '.js')

        .then(function (r) { return r.json(); })

        .then(function (p) {

          var m = {};

          (p.variants || []).forEach(function (v) { m[v.id] = v.compare_at_price || 0; });

          comparaCache[h] = m;

        })

        .catch(function () { comparaCache[h] = {}; });

    }));

  }



  function comparaDe(it) {

    var m = comparaCache[it.handle];

    return (m && m[it.variant_id]) || 0;

  }



  /* ---------- artículos ---------- */

  function pintarItems() {

    if (!cart || !cart.items.length) {

      elItems.innerHTML = '';

      return;

    }

    elItems.innerHTML = cart.items.map(function (it, idx) {

      var linea = idx + 1;

      // el precio "antes" es el mayor entre el compare_at del producto y el precio de línea sin descuentos

      var compara = comparaDe(it) * it.quantity;

      var original = Math.max(compara, it.original_line_price);

      var final = it.final_line_price;

      var ahorro = original - final;

      var img = imagenPorAltura(it.image, 176);

      var opts = (it.options_with_values || [])

        .filter(function (o) { return o.value && o.value !== 'Default Title'; })

        .map(function (o) { return esc(o.name) + ': ' + esc(o.value); }).join(', ');



      return '<li class="item" data-linea="' + linea + '">' +

        // sin loading="lazy": UpCart tampoco lo usa y en el carrito la imagen

        // debe verse en cuanto se abre el cajón (con lazy no llegaba a cargar)

        (img ? '<a href="' + esc(it.url) + '"><img class="item__img" src="' + esc(img) + '" alt="' + esc(it.product_title) + '" width="88" height="88"></a>'

             : '<div class="item__img"></div>') +

        '<div class="item__info">' +

          '<div class="item__top">' +

            '<h4 class="item__title"><a href="' + esc(it.url) + '">' + esc(it.product_title) + '</a></h4>' +

            '<button class="item__rm" data-quitar="' + linea + '" aria-label="Quitar">' + ICONO_PAPELERA + '</button>' +

          '</div>' +

          (opts ? '<div class="item__opt">' + opts + '</div>' : '') +

          '<div class="item__prices">' +

            (ahorro > 0 ? '<span class="item__was">' + money(original) + '</span>' : '') +

            '<span class="item__now">' + money(final) + '</span>' +

            (ahorro > 0 ? '<span class="item__save">(' + T.ahorras + ' ' + money(ahorro) + ')</span>' : '') +

          '</div>' +

          '<div class="qty">' +

            '<button data-mas="' + linea + '" data-delta="-1" aria-label="Menos">−</button>' +

            '<span>' + it.quantity + '</span>' +

            '<button data-mas="' + linea + '" data-delta="1" aria-label="Más">+</button>' +

          '</div>' +

        '</div>' +

      '</li>';

    }).join('');

  }



  /* ---------- upsells ---------- */

  function reglasQueAplican() {

    if (!CFG.upsells || !CFG.upsells.activo || !cart || !cart.items.length) return [];

    var mapa = CFG.mapaColecciones || {};

    var idsEnCarrito = cart.items.map(function (i) { return i.product_id; });



    return (CFG.reglas || []).filter(function (r) {

      var porProducto = (r.dispProductos || []).some(function (pid) {

        return idsEnCarrito.indexOf(pid) !== -1;

      });

      if (porProducto) return true;

      return (r.dispColecciones || []).some(function (h) {

        var lista = mapa[h] || [];

        return idsEnCarrito.some(function (pid) { return lista.indexOf(pid) !== -1; });

      });

    }).sort(function (a, b) { return a.prioridad - b.prioridad; });

  }



  function cargarUpsells() {

    var reglas = reglasQueAplican();

    log('reglas que aplican:', reglas.map(function (r) { return r.nombre; }));

    if (!reglas.length) { elUp.innerHTML = ''; return Promise.resolve(); }



    var tareas = reglas.map(function (r) {

      if (r.mostrarColeccion) return traerColeccion(r.mostrarColeccion, r.maximo).then(function (ps) { return { r: r, ps: ps }; });

      if ((r.mostrarProductos || []).length) {

        return Promise.all(r.mostrarProductos.map(traerProducto)).then(function (arrs) {

          return { r: r, ps: [].concat.apply([], arrs) };

        });

      }

      return Promise.resolve({ r: r, ps: [] });

    });



    return Promise.all(tareas).then(function (res) {

      var enCarrito = cart.items.map(function (i) { return i.product_id; });

      var vistos = {}, salida = [];

      res.forEach(function (x) {

        var tomados = 0;

        x.ps.forEach(function (p) {

          if (salida.length >= (CFG.upsells.maximoTotal || 10)) return;

          if (tomados >= (x.r.maximo || 10)) return;

          if (vistos[p.id]) return;

          if (CFG.upsells.ocultarSiYaEstaEnCarrito && enCarrito.indexOf(p.id) !== -1) return;

          if (!p.variants || !p.variants.length) return;

          vistos[p.id] = true; tomados++; salida.push(p);

        });

      });

      pintarUpsells(salida);

    });

  }



  function precioNum(v) { return typeof v === 'string' ? Math.round(parseFloat(v) * 100) : v; }



  function pintarUpsells(productos) {

    if (!productos.length) { elUp.innerHTML = ''; return; }

    if (upsellSlide >= productos.length) upsellSlide = 0;



    var slides = productos.map(function (p) {

      var v0 = p.variants[0];

      var precio = precioNum(v0.price);

      var compara = precioNum(v0.compare_at_price);

      var img = (p.images && p.images[0]) || p.featured_image || '';

      if (img && typeof img === 'object') img = img.src;

      img = imagenPorAltura(img, 180);



      var disponibles = p.variants.filter(function (v) { return v.available !== false; });

      var lista = disponibles.length ? disponibles : p.variants;

      var opciones = lista.map(function (v) {

        return '<option value="' + v.id + '">' + esc(v.title) + '</option>';

      }).join('');

      var unaSola = lista.length === 1 && /default/i.test(lista[0].title || '');



      return '<div class="up__slide">' +

        '<div class="tile">' +

          (img ? '<a href="/products/' + esc(p.handle) + '"><img class="tile__img" src="' + esc(img) + '" alt="' + esc(p.title) + '" width="90" height="90"></a>' : '<div class="tile__img"></div>') +

          '<div class="tile__info">' +

            '<div class="tile__title"><a href="/products/' + esc(p.handle) + '">' + esc(p.title) + '</a></div>' +

            '<div class="tile__prices">' +

              (compara && compara > precio ? '<span class="tile__was">' + money(compara) + '</span>' : '') +

              '<span class="tile__now">' + money(precio) + '</span>' +

            '</div>' +

            '<div class="tile__bottom">' +

              (unaSola ? '' : '<select class="tile__sel">' + opciones + '</select>') +

              '<button class="tile__add" data-agregar="' + lista[0].id + '">' + esc(T.anadir) + '</button>' +

            '</div>' +

          '</div>' +

        '</div>' +

      '</div>';

    }).join('');



    elUp.innerHTML =

      '<div class="up">' +

        '<div class="up__row">' +

          '<button class="up__nav" data-dir="prev" aria-label="Anterior">‹</button>' +

          '<div class="up__win"><div class="up__track" style="transform:translateX(-' + (upsellSlide * 100) + '%)">' + slides + '</div></div>' +

          '<button class="up__nav" data-dir="next" aria-label="Siguiente">›</button>' +

        '</div>' +

      '</div>';



    var total = productos.length;

    elUp.querySelector('[data-dir="prev"]').disabled = upsellSlide === 0;

    elUp.querySelector('[data-dir="next"]').disabled = upsellSlide >= total - 1;

    elUp._total = total;

  }



  /* ---------- pie ---------- */

  function pintarPie() {

    if (!cart || !cart.items.length) { elFt.innerHTML = ''; elFt.style.display = 'none'; return; }

    elFt.style.display = '';

    // Solo descuentos REALES del carrito, no la diferencia con el precio tachado.

    // (UpCart usa el mismo criterio: savingsRowBehaviour = "discount_only".)

    // OJO: los descuentos automáticos de la tienda son a nivel de CARRITO, no de línea:

    // las líneas quedan intactas (original_line_price == final_line_price) y el importe

    // solo aparece en total_discount. Restar por línea daba siempre 0.

    var ahorro = cart.total_discount || (cart.original_total_price - cart.total_price) || 0;

    // Pastillas con el NOMBRE de cada descuento aplicado, como hace UpCart

    var etiquetas = (cart.cart_level_discount_applications || []).map(function (d) {

      return '<span class="ft__tag">' + ICONO_ETIQUETA + '<span>' + esc(d.title) + '</span></span>';

    }).join('');



    elFt.innerHTML =

      (ahorro > 0

        ? '<div class="ft__row">' +

            '<div class="ft__left"><span class="ft__label">' + T.descuentos + '</span>' + etiquetas + '</div>' +

            '<span class="ft__amount">- ' + money(ahorro) + '</span>' +

          '</div>'

        : '') +

      // Formulario nativo (POST /cart con name="checkout"), que es como lo hace Dawn.

      // Un simple <a href="/checkout"> no navegaba dentro del editor de temas.

      // OJO: NO poner target="_top". En el editor de temas la tienda va en un iframe de

      // otro origen y el navegador BLOQUEA la navegación de la ventana completa, con lo

      // que el botón deja de hacer nada. Sin target funciona en pestaña normal (que es

      // donde se paga de verdad) y dentro del editor al menos navega el marco.

      '<form class="ft__form" action="/cart" method="post">' +

        '<button class="ft__btn" type="submit" name="checkout">' +

          T.checkout.replace('{total}', money(cart.total_price)) +

        '</button>' +

      '</form>' +

      (CFG.trustBadges && CFG.trustBadges.activo && CFG.trustBadges.html

        ? '<div class="ft__badges">' + CFG.trustBadges.html + '</div>' : '');

  }



  /* ---------- pintado general ---------- */

  function pintar() {

    var n = cart ? cart.item_count : 0;


    if (!cart || !n) {

      elItems.innerHTML = '';

      elUp.innerHTML = '';

      elFt.innerHTML = ''; elFt.style.display = 'none';

      elRw.innerHTML = '<div class="empty">' + esc(T.vacio) + '</div>';

      return;

    }

    return enriquecerPrecios().then(function () {

      pintarRecompensas();

      pintarItems();

      pintarPie();

      return cargarUpsells();

    });

  }



  function refrescar() {

    return getCart().then(function (c) {

      cart = c; actualizarBurbuja(); return pintar();

    });

  }



  function actualizarBurbuja() {

    if (!cart) return;

    document.querySelectorAll('.cart-count-bubble span[aria-hidden], #cart-icon-bubble .cart-count-bubble span').forEach(function (el) {

      el.textContent = cart.item_count;

    });

  }



  /* Mientras el tema está en BORRADOR, Shopify inyecta su barra de vista previa fija

     abajo (#PBarNextFrameWrapper) y tapa la parte inferior del botón de pago: al tocar

     el centro-abajo el clic se lo lleva su iframe. Le sumamos su altura al margen

     inferior. En el tema publicado la barra no existe y esto vale 0, así que el

     diseño final no cambia. */

  function ajustarBarraPreview() {

    var pbar = document.getElementById('PBarNextFrameWrapper');

    var alto = pbar ? Math.round(pbar.getBoundingClientRect().height) : 0;

    wrap.style.setProperty('--am-barra-preview', alto + 'px');

  }



  /* ---------- abrir / cerrar ---------- */

  function abrir() {

    ajustarBarraPreview();

    abierto = true;

    elBackdrop.classList.add('on');

    elCard.classList.add('on');

    // Bloquear el scroll en el BODY, no en el <html>: si se bloquea el html, Safari de

    // iOS considera la página no desplazable y despliega la barra de navegación completa

    // (con botones), en vez de dejar la píldora minimizada del dominio. UpCart hace lo mismo.

    document.body.style.overflow = 'hidden';

    refrescar();

  }

  function cerrar() {

    abierto = false;

    elBackdrop.classList.remove('on');

    elCard.classList.remove('on');

    document.body.style.overflow = '';

  }



  /* ---------- eventos internos ---------- */

  wrap.addEventListener('click', function (e) {

    var t = e.target.closest ? e.target.closest('[data-cerrar],[data-quitar],[data-mas],[data-agregar],[data-dir]') : null;

    if (!t) return;



    if (t.hasAttribute('data-cerrar')) { cerrar(); return; }

    if (ocupado) return;



    if (t.hasAttribute('data-dir')) {

      var total = elUp._total || 1;

      upsellSlide += (t.getAttribute('data-dir') === 'next' ? 1 : -1);

      upsellSlide = Math.max(0, Math.min(upsellSlide, total - 1));

      var track = elUp.querySelector('.up__track');

      if (track) track.style.transform = 'translateX(-' + (upsellSlide * 100) + '%)';

      elUp.querySelector('[data-dir="prev"]').disabled = upsellSlide === 0;

      elUp.querySelector('[data-dir="next"]').disabled = upsellSlide >= total - 1;

      return;

    }



    if (t.hasAttribute('data-quitar')) {

      ocupado = true;

      cambiar(parseInt(t.getAttribute('data-quitar'), 10), 0)

        .then(function (c) { cart = c; pintar(); actualizarBurbuja(); })

        .finally(function () { ocupado = false; });

      return;

    }



    if (t.hasAttribute('data-mas')) {

      var linea = parseInt(t.getAttribute('data-mas'), 10);

      var delta = parseInt(t.getAttribute('data-delta'), 10);

      var actual = cart.items[linea - 1];

      if (!actual) return;

      ocupado = true;

      cambiar(linea, Math.max(0, actual.quantity + delta))

        .then(function (c) { cart = c; pintar(); actualizarBurbuja(); })

        .finally(function () { ocupado = false; });

      return;

    }



    if (t.hasAttribute('data-agregar')) {

      var tile = t.closest('.tile');

      var sel = tile ? tile.querySelector('.tile__sel') : null;

      var vid = sel ? parseInt(sel.value, 10) : parseInt(t.getAttribute('data-agregar'), 10);

      ocupado = true; t.disabled = true;

      agregar(vid, 1)

        .then(function () { return refrescar(); })

        .finally(function () { ocupado = false; });

      return;

    }

  });



  wrap.addEventListener('change', function (e) {

    if (!e.target.classList.contains('tile__sel')) return;

    var btn = e.target.closest('.tile').querySelector('.tile__add');

    if (btn) btn.setAttribute('data-agregar', e.target.value);

  });



  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && abierto) cerrar(); });



  /* ---------- integración con el tema ---------- */

  // 1) interceptar cualquier añadido al carrito hecho por el tema u otras apps

  var fetchOriginal = window.fetch;

  window.fetch = function () {

    var url = arguments[0];

    var href = typeof url === 'string' ? url : (url && url.url) || '';

    var esAdd = /\/cart\/add(\.js)?/.test(href);

    var esCambio = /\/cart\/(change|update)(\.js)?/.test(href);

    return fetchOriginal.apply(this, arguments).then(function (res) {

      if (esAdd && res.ok) { setTimeout(function () { abrir(); }, 60); }

      else if (esCambio && res.ok && abierto) { setTimeout(refrescar, 60); }

      return res;

    });

  };



  // 2) respaldo para formularios que el tema NO maneja por JS.

  //    Va en fase de burbuja y comprueba defaultPrevented: si Dawn (u otra app) ya

  //    interceptó el submit y hará su propio fetch, aquí no hacemos nada.

  //    Sin esto, un solo clic añadía el artículo dos veces.

  document.addEventListener('submit', function (e) {

    if (e.defaultPrevented) return;

    var f = e.target;

    if (!f || !f.action || !/\/cart\/add/.test(f.action)) return;

    e.preventDefault();

    fetchOriginal('/cart/add.js', { method: 'POST', body: new FormData(f) })

      .then(function () { abrir(); });

  }, false);



  // 3) el ícono del carrito abre el cajón en vez de ir a /cart

  document.addEventListener('click', function (e) {

    var a = e.target.closest && e.target.closest('a[href$="/cart"], a[href*="/cart?"], #cart-icon-bubble');

    if (!a) return;

    e.preventDefault();

    abrir();

  }, true);



  /* ---------- arranque ---------- */

  getCart().then(function (c) { cart = c; log('carrito inicial', c.item_count, 'artículos'); });



  window.amCart = { abrir: abrir, cerrar: cerrar, refrescar: refrescar, estado: function () { return cart; }, config: CFG };

  log('listo — ' + (CFG.reglas || []).length + ' reglas cargadas');

})();

